var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Apexcharts',{ref:"chart",attrs:{"type":"line","height":"500","options":_vm.options,"series":_vm.series},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }